import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import { Tooltip } from "react-tooltip";

// Returns true if filter values a and b conflict (duplicate, subset, or superset).
const areFiltersConflicting = (a, b) => {
  if (!a || !b) return false;
  const aVal = a.trim();
  const bVal = b.trim();
  if (aVal === bVal) return true;

  // Wildcard (*) conflict checks removed — only exact 10-digit numbers are now allowed.
  // const aIsPrefix = aVal.endsWith("*") && !aVal.startsWith("*");
  // const bIsPrefix = bVal.endsWith("*") && !bVal.startsWith("*");
  // const aIsSuffix = aVal.startsWith("*") && !aVal.endsWith("*");
  // const bIsSuffix = bVal.startsWith("*") && !bVal.endsWith("*");
  //
  // if (aIsPrefix && bIsPrefix) {
  //   const ap = aVal.slice(0, -1);
  //   const bp = bVal.slice(0, -1);
  //   return ap.startsWith(bp) || bp.startsWith(ap);
  // }
  // if (aIsSuffix && bIsSuffix) {
  //   const as_ = aVal.slice(1);
  //   const bs = bVal.slice(1);
  //   return as_.endsWith(bs) || bs.endsWith(as_);
  // }
  // if (aIsPrefix) return bVal.startsWith(aVal.slice(0, -1));
  // if (bIsPrefix) return aVal.startsWith(bVal.slice(0, -1));
  // if (aIsSuffix) return bVal.endsWith(aVal.slice(1));
  // if (bIsSuffix) return aVal.endsWith(bVal.slice(1));

  return false;
};

const getConflictingFilter = (newValue, filters, excludeValue = null) => {
  const newVal = newValue.trim();
  if (!newVal) return null;
  for (const filter of filters) {
    const existingVal = (filter.value || "").trim();
    if (!existingVal) continue;
    if (excludeValue !== null && existingVal === excludeValue.trim()) continue;
    if (areFiltersConflicting(newVal, existingVal)) return filter;
  }
  return null;
};

const EditCallerID = (props) => {
  const { t, i18n } = useTranslation();
  const nameRef = useRef();
  const [isloading, setIsloading] = useState(false);
  const [filterLabel, setFilterLabel] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [isValidName, setIsValidName] = useState(true);
  const [isValidPh, setIsValidPh] = useState(true);
  // const [isTooShort, setIsTooShort] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [isDuplicateName, setIsDuplicateName] = useState(false);
  const [conflictingFilter, setConflictingFilter] = useState(null);

  useEffect(() => {
    if (props.editData) {
      setFilterLabel(props.editData.name || "");
      setFilterValue(props.editData.value || "");
    }
  }, [props.editData]);

  const isDuplicateFilter = (name) => {
    if (!name || name.trim() === "") return false;
    const existingFilters = props.existingFilters || [];
    const originalName = props.editData?.name || "";
    return existingFilters.some(
      (filter) =>
        filter.name &&
        filter.name.toLowerCase() === name.trim().toLowerCase() &&
        filter.name.toLowerCase() !== originalName.toLowerCase()
    );
  };

  function addCFilter(e) {
    e.preventDefault();
    e.stopPropagation();
    validateName(filterLabel);
    validatePh(filterValue);
    const duplicate = isDuplicateFilter(filterLabel);
    setIsDuplicateName(duplicate);
    const conflict = isValidPh
      ? getConflictingFilter(filterValue, props.existingFilters || [], props.editData?.value)
      : null;
    setConflictingFilter(conflict);

    if (isValidName && isValidPh && !duplicate && !conflict) {
      // Passing updated values back to parent
      props.addCFilter(e, filterLabel, filterValue, 1);
    }
  }

  const validateName = (value) => {
    setIsError(false);
    const callerIDRegex = /^[a-zA-Z0-9\s\-_]*$/;
    if (value && value.length >= 1 && value.match(callerIDRegex)) {
      setIsValidName(true);
    } else {
      setIsError(true);
      setIsValidName(false);
    }
  };

  const validatePh = (value) => {
    // Old regex allowed * wildcards and short values — removed:
    // if (value && value.length >= 3) {
    //   setIsTooShort(false);
    //   setIsError(false);
    //   const phoneNumberRegex = /^(?!.*\*\*)(?:(\+1|1)?[2-9]\d{2}[2-9]\d{6}|\*\d{3,}|\d{3,}\*)$/;
    //   if (value.match(phoneNumberRegex)) {
    //     setIsValidPh(true);
    //   } else {
    //     setIsError(true);
    //     setIsValidPh(false);
    //   }
    // } else if (value && value.length > 0) {
    //   setIsTooShort(true);
    //   setIsError(true);
    //   setIsValidPh(false);
    // } else {
    //   setIsTooShort(false);
    // }
    const phoneNumberRegex = /^\d{10}$/;
    const trimmed = (value || "").trim();
    if (trimmed === "") {
      setIsError(false);
      setIsValidPh(true);
      return;
    }
    if (phoneNumberRegex.test(trimmed)) {
      setIsError(false);
        setIsValidPh(true);
      } else {
        setIsError(true);
        setIsValidPh(false);
      }
  };

  const handlePhoneNumberChange = (event) => {
    const value = event.target.value;
    setFilterValue(value);
    setIsEdited(true);
    validatePh(value);
    // Old regex allowed * wildcards — removed:
    // const phoneNumberRegex = /^(?!.*\*\*)(?:(\+1|1)?[2-9]\d{2}[2-9]\d{6}|\*\d{3,}|\d{3,}\*)$/;
    // const isPhValid = value && value.length >= 3 && phoneNumberRegex.test(value);
    const phoneNumberRegex = /^\d{10}$/;
    const isPhValid = value && phoneNumberRegex.test(value.trim());
    setConflictingFilter(
      isPhValid
        ? getConflictingFilter(value, props.existingFilters || [], props.editData?.value)
        : null
    );
  };

  const handleNameChange = (event) => {
    const value = event.target.value;
    setFilterLabel(value);
    setIsEdited(true);
    validateName(value);
    setIsDuplicateName(isDuplicateFilter(value));
  };

  useEffect(() => {
    if (nameRef) {
      setTimeout(() => {
        nameRef.current.focus();
      }, 500);
    }
  }, []);

  return (
    <>
      <div>
        <div className="tel-numbers">
          <strong>{t("name")}</strong>
        </div>
        <div className="form pt-1">
          <input
            ref={nameRef}
            type="text"
            className="form-control w-100"
            tabIndex={-1}
            maxLength={15}
            value={filterLabel}
            onChange={(e) => handleNameChange(e)}
          />
          {/* Show error only if edited and invalid */}
          {isError && !isValidName && isEdited && (
            <p style={{ color: "red" }}>{t("alphanumeritext")}</p>
          )}
          {isDuplicateName && isEdited && (
            <p style={{ color: "red" }}>Filter name already exists.</p>
          )}

          <div className="tel-numbers mt-2">
            <strong>{t("Filter")}</strong>
          </div>
          <div className="form position-relative">
            <input
              type="text"
              className="form-control w-100"
              tabIndex={-2}
              maxLength={10}
              value={filterValue}
              onChange={(e) => handlePhoneNumberChange(e)}
            />
            <div className="addFilterInfoIcon">
              <MDBIcon fas icon="info-circle" className="deleteToolTip" />
            </div>
          </div>
          <p className="text-secondary">
            {/* Enter a 10 digit phone number, use * as a wildcard. */}
            Enter a 10 digit phone number.
          </p>
          {/* Show error only if edited and invalid */}
          {/* {isError && !isValidPh && isEdited && isTooShort && (
            <p style={{ color: "red" }}>At least 3 digits are required to create a filter</p>
          )}
          {isError && !isValidPh && isEdited && !isTooShort && (
            <p style={{ color: "red" }}>{t("validnumber")}</p>
          )} */}
          {isError && !isValidPh && isEdited && (
            <p style={{ color: "red" }}>{t("validnumber")}</p>
          )}
          {isValidPh && conflictingFilter && isEdited && (
            <p style={{ color: "red" }}>
              Filter value conflicts with existing filter &quot;{conflictingFilter.name}&quot; ({conflictingFilter.value}).
            </p>
          )}
        </div>
        <MDBModalFooter>
          <MDBBtn color="secondary" onClick={props.toggleCFilter}>
            {t("close")}
          </MDBBtn>
          <MDBBtn onClick={addCFilter}>{t("Save")}</MDBBtn>
        </MDBModalFooter>
      </div>
      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
        {/* The filter length must be 10 digits. You can use '*' as a wildcard. */}
        The filter must be exactly 10 digits.
      </Tooltip>
    </>
  );
};

export default EditCallerID;
